<template>
  <PageLayout>
    <PageHeader
      :title="$t(`Common.title.useRule`)"
      :breadcrumb="[
        {
          title: `${$t('Common.title.homeTitle')}`,
        },
        {
          title: `${this.$t(
            `Common.title.${this.$route.params?.name?.toString()}`
          )}`,
        },
      ]"
    />
    <div class="px-4">
      <div
        class="px-4"
        style="font-size: 18px"
        v-html="$t('Common.title.useRuleStr')"
      ></div>
    </div>

    <template slot="actions">
      <m-button
        type="primary"
        ghost
        size="large"
        @click="onClose"
        class="mr-4"
        >{{ this.$t('Common.action.disagree') }}</m-button
      >
      <m-button type="primary" size="large" @click="onNext">{{
        this.$t('Common.action.agree')
      }}</m-button>
    </template>
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/Layout/web/PageLayout.vue';
import PageHeader from 'common/components/Layout/web/PageHeader.vue';

export default {
  name: 'Home',
  components: {
    PageLayout,
    PageHeader,
  },
  data() {
    return {};
  },
  methods: {
    onClose() {
      this.$router.back();
    },
    onNext() {
      if (this.$route.params?.name === 'search') {
        this.$router.push(`/search/${this.$route.params?.name}`);
      } else {
        this.$router.push(`/apply/${this.$route.params?.name}`);
      }
    },
  },
  created() {},
};
</script>
